import { GroupStandingData } from '../types';
import { EHttpMethod, usePortalQuery } from './usePortalQuery';

export const useGroupStandingData = (): { isLoading: boolean; standingData: GroupStandingData } => {
  const { data: standingData, isLoading } = usePortalQuery<GroupStandingData>(
    EHttpMethod.GET,
    'standing-data/group',
    'get-group-standng-data',
    true,
    undefined,
    undefined,
    undefined,
    false,
    600000, //  ensure data is not stale for 10 minutes
    600000 // prevent data being garbage collected for 10 minutes
  );

  return {
    isLoading,
    standingData: {
      standingDataGroupTypeList: standingData?.standingDataGroupTypeList ?? []
    }
  };
};
